<template>
    <div class="mb-3">
        <div class="row">
            <h3 class="text-center">{{this.title}}</h3>
            <div class="col">
                <div class="mb-3 mt-4">
                    <template  v-for="(label,field) in this.fieldsToReview">
                        <div class="mb-3" v-if="this.leadData.hasOwnProperty(field)">
                            <label :for="field" class="form-label">{{ label }}</label>
                            <div class="input-group">
<!--                                <div class="input-group-text">-->
<!--                                    <input class="form-check-input mt-0" type="checkbox" value="1" checked aria-label="Checkbox for following text input">-->
<!--                                </div>-->
                                <input class="form-control pac-target-input disabled" type="text" disabled readonly :value="this.leadData[field]">
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-lg-6 offset-lg-3">
                <div class="text-center">
                    <a id="btnNext" class="btn btn-lg w-100 btn-primary" role="button" @click.prevent="this.handleCorrectData">Yes, everything looks correct!</a>
                </div>
                <div class="text-center mt-3">
                    <a id="btnNext" class="btn btn-xs w-100 btn-outline-secondary" role="button" @click.prevent="this.handleWrongData">No, I need to make changes</a>
                </div>
            </div>
        </div>

<!--        <div class="mt-4">-->
<!--        </div>-->
    </div>

</template>

<script>
export default {
    name: 'ReviewData',
    emits: ['confirmDataIsCorrect', 'confirmDataIsWrong'],
    props: {
        uid: {
            type: String,
            required: true,
        },
        selectedProduct: {
            type: String,
            required: false,
        },
    },
    data: function() {
        return {
            leadData: {},
            fieldsToReview: {
                'first_name': 'First Name',
                'last_name': 'Last Name',
                'email': 'Email',
                'cell_phone': 'Phone',
                'address': 'Address',
                'province': 'Province',
                'postal_code': 'Postal Code',
                'dob': 'Year of Birth',
            },
        }
    },
    mounted() {
        console.log('ReviewData mounted');
        let dataInLocalStorage = JSON.parse(localStorage.getItem(`refresh-results-${this.uid}`)) ?? {};
        console.log('dataInLocalStorage');
        console.log(dataInLocalStorage);
        this.leadData = dataInLocalStorage.lead_data ?? {};
    },
    methods: {
        async handleCorrectData() {

            let productName = this.selectedProduct ?? 'personal_loan';
            let data = {
                uid: this.uid,
                product_name: ['personal_loan', 'car_loan'].includes(productName) ? productName : 'personal_loan',
            };

            let apiResponse = await
                axios.post('/portal/refresh-data/prepop', data)
                    .then(res => {
                        return res.data;
                    }).catch(err => {
                    // TODO -- email exception?
                    return false;
                });

            console.log('apiResponse');
            console.log(apiResponse);
            if(apiResponse && apiResponse.hasOwnProperty('status') && apiResponse['status'] == 'success') {
                console.log('redirecting');
                let redirectToPrepopPage = apiResponse.redirect_url.length > 0 ? apiResponse.redirect_url : '/loan';
                // redirect to next page using JS
                window.location.href = redirectToPrepopPage;
            }
            // this.$emit('confirmDataIsCorrect');
        },
        handleWrongData() {
            let productNameRoutes = {
                'personal_loan' : 'loan',
                'car_loan' : 'car'
            };
            let url = `/${productNameRoutes[this.selectedProduct] ?? 'loan'}`;

            window.open(url, '_blank');
            // this.$emit('confirmDataIsWrong');
        },
    },
    computed: {
        title() {
            let productNames = {
                'personal_loan' : 'Personal Loan',
                'car_loan' : 'Car Loan'
            };

            let productName = productNames[this.selectedProduct] ?? null;

            if(productName) {
                return `Refresh Your ${productName} Offers!`;
            }
            else {
                return `Refresh Your Offers!`;
            }
        }
    },
}
</script>
